import {Button, Slide} from "@mui/material";
import Box from "@mui/material/Box";
import NotifyElectronicSignature from "./NotifyElectronicSignature";
import {Error} from "@mui/icons-material";
import Modal from "../../../../../../../material/modal/Modal";
import ModalConfig from "../../../../../../../material/modal/ModalConfig";
import ElectronicSignatureTutorial from "../../common/electronic-signature/ElectronicSignatureTutorial";
import {useState} from "react";

export default function ({onSkip}) {
    const [openHelp, setOpenHelp] = useState(false);

    const toggleOpenHelp = o => () => setOpenHelp(o);
    const toggleSkipSignature = o => () => {
        onSkip(true);

        setOpenHelp(false);
    }

    return (
        <Slide in={true} direction={"up"} timeout={500}>
            <div>
                <Box mt={2}>
                    <NotifyElectronicSignature/>
                </Box>
                <Box mt={5} px={2} display="flex" justifyContent="center">
                    <Button
                        startIcon={<Error/>}
                        variant={"contained"}
                        color={"error"}
                        fullWidth
                        onClick={toggleOpenHelp(true)}
                        data-test="open-signature-tutorial"
                    >
                        Le sociétaire rencontre un problème
                    </Button>
                </Box>

                {
                    openHelp
                        ? (
                            <Modal
                                modalConfig={
                                    new ModalConfig()
                                        .setWidth("100%")
                                        .setHeight("100%")
                                        .setOnClose(toggleOpenHelp(false))
                                        .setComponent(<ElectronicSignatureTutorial
                                            onSkip={toggleSkipSignature(true)}
                                            skipMessage={"Passer le PV"}
                                        />)
                                }
                            />
                        )
                        : null
                }
            </div>
        </Slide>
    )
}